module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/cogs-45a17205b2f5609045c4d333c286763f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/cogs.svg
// module id = a8JP
// module chunks = 24